module.exports = __webpack_public_path__ + "static/media/go-big-go-home-dual-cta.e0350bb3.webp";